import { nextTick, ref, watch } from 'vue'

// Dirty tracking for a settings page, in the shape SaveBar wants.
//
// `hasUnsavedChanges` flips true when any of `sources` changes — but never
// because of a load. Loading writes the server's values straight into the same
// local state the merchant edits, which looks identical to an edit, so wrap
// every load in `reload()`: it disarms the watch for the duration and only
// re-arms once the watch has flushed. Clearing the flag afterwards instead is
// what made the SaveBar flash on the way into a page.
//
// Deep by default: these forms nest (a questions list, a winback segment), and
// a shallow watch would miss an edit inside one.
export function useUnsavedChanges(sources) {
  const hasUnsavedChanges = ref(false)
  let tracking = false

  watch(
    sources,
    () => {
      if (tracking) hasUnsavedChanges.value = true
    },
    { deep: true }
  )

  const settle = () =>
    nextTick().then(() => {
      hasUnsavedChanges.value = false
      tracking = true
    })

  const resume = error =>
    nextTick().then(() => {
      tracking = true
      throw error
    })

  const reload = loads => {
    tracking = false
    return Promise.all([].concat(loads)).then(settle, resume)
  }

  return { hasUnsavedChanges, reload }
}
